import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Button } from "@/components/ui/button";
import { Compass } from "lucide-react";

const ArchitectsSection = () => {
  const ref = useScrollReveal();

  return (
    <section className="py-20 bg-background" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="animate-on-scroll max-w-4xl mx-auto bg-dark rounded-2xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-32 h-32 bg-primary/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-24 h-24 bg-primary/5 rounded-full translate-x-1/2 translate-y-1/2" />

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
                <Compass className="text-primary" size={40} />
              </div>
            </div>
            <div className="flex-1 text-center md:text-right">
              <h2 className="text-2xl md:text-3xl font-bold text-dark-foreground mb-4">
                לאדריכלים ומתכננים – <span className="text-primary">שותפות מקצועית</span>
              </h2>
              <p className="text-dark-foreground/90 leading-relaxed mb-6">
                אני מזמין אדריכלים ומתכננים לשיתוף פעולה טכני צמוד. מהשלב התכנוני ועד הביצוע –
                אני מביא את הידע המעשי שמבטיח שהעיצוב שלכם ייושם בצורה מושלמת, עם אחריות מלאה על התוצאה.
              </p>
              <Button asChild className="bg-primary text-primary-foreground hover:bg-gold-light font-bold">
                <a href="#contact">בואו נדבר על הפרויקט הבא</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArchitectsSection;
